import React, { useEffect, useState } from 'react';

import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import { Assignment } from '@material-ui/icons';
import { nDecimal } from 'hooks/Pipe';
import { wsGetAll } from 'services/WService';

export default function WritePurchaseData(props) {
  const { inputChange, dataProduct } = props; //data Products

  const [measureUnits, setMeasureUnits] = useState([]);
  const [LengthUnits, setLengthUnits] = useState([]);
  const [taxs, setTaxs] = useState([]);

  async function listMeasureUnits() {
    let response = await wsGetAll('logi/measure-unit');
    if (response.success) setMeasureUnits(response.data);
  }

  async function listLengthUnits() {
    let response = await wsGetAll('logi/length-unit');
    if (response.success) setLengthUnits(response.data);
  }

  async function listTaxs() {
    let response = await wsGetAll('base/tax');
    if (response.success) setTaxs(response.data);
  }

  useEffect(() => {
    listMeasureUnits();
    listLengthUnits();
    listTaxs();
  }, []);

  return (
    <>
      <GridItem xs={12} sm={12} md={6}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Artículo compra</h4>
          </CardHeader>

          <CardBody>
            <GridContainer>
              <GridItem xs={12} md={12} xl={3}>
                <FormControl fullWidth margin="normal">
                  <InputLabel>Unidad medida</InputLabel>
                  <Select
                    value={dataProduct.logi_measure_unit_id_BuyUnitMsr || ''}
                    required
                    inputProps={{
                      name: 'logi_measure_unit_id_BuyUnitMsr',
                      onChange: inputChange,
                    }}
                  >
                    {measureUnits.map((item) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.UgpName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={12} xl={3}>
                <TextField
                  label="Unidades compra"
                  name="NumInBuy"
                  value={nDecimal(dataProduct.NumInBuy)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} md={12} xl={3}>
                <TextField
                  label="Precio compra"
                  name="purchase_price"
                  value={nDecimal(dataProduct.purchase_price)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} md={12} xl={3}>
                <FormControl fullWidth margin="normal">
                  <InputLabel>Indicador impuesto</InputLabel>
                  <Select
                    value={dataProduct.base_tax_id || ''}
                    inputProps={{
                      name: 'base_tax_id',
                      onChange: inputChange,
                    }}
                  >
                    {taxs.map((item) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.Code}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>

              <GridItem xs={12} md={12} xl={3}>
                <AllowedGuard
                  permission={
                    ConstantPermissions.LOGI_PRODUCTS_PURCHASE_DATA_UPDATE_LAST_PURCHASE_PRICE
                  }
                  component={
                    <>
                      <h6>Último precio de compra</h6>
                      <p>{dataProduct.last_purchase_price || '-'}</p>
                    </>
                  }
                >
                  <TextField
                    label="Último Precio compra"
                    name="last_purchase_price"
                    value={dataProduct.last_purchase_price}
                    inputProps={{ onChange: inputChange, min: 0 }}
                    type="number"
                    margin="normal"
                    fullWidth
                  />
                </AllowedGuard>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Medidas</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} lg={6} xl={4}>
                <TextField
                  label="Logintud"
                  name="BLength1"
                  value={nDecimal(dataProduct.BLength1)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} lg={6} xl={4}>
                <TextField
                  label="Ancho"
                  name="BWidth1"
                  value={nDecimal(dataProduct.BWidth1)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} lg={6} xl={4}>
                <TextField
                  label="Altura"
                  name="BHeight1"
                  value={nDecimal(dataProduct.BHeight1)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} lg={6} xl={4}>
                <FormControl fullWidth margin="normal">
                  <InputLabel>Unid. de volumen</InputLabel>
                  <Select
                    value={dataProduct.logi_length_unit_id_BVolUnit || ''}
                    inputProps={{
                      name: 'logi_length_unit_id_BVolUnit',
                      onChange: inputChange,
                    }}
                  >
                    {LengthUnits.map((item) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.UnitName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} lg={6} xl={4}>
                <TextField
                  name="BVolume"
                  label="Volumen"
                  value={nDecimal(dataProduct.BVolume)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} lg={6} xl={4}>
                <TextField
                  label="Peso"
                  name="BWeight1"
                  value={nDecimal(dataProduct.BWeight1)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </>
  );
}
